import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import '../css/gallerySlide.css';

import Header from 'common/js/header/header';
import GallerySlideComponent from "./gallerySlideComponent";
import { getGalleryListSvc } from "../slidesSvc";
import { update } from "lodash";

function GallerySlide() {
  const [loader, setLoader] = useState("none");
  const [opacity, setOpacity] = useState(1);
  const [ptmId, setPtmId] = useState(0);
  const [lstPtmGallery, setLstPtmGallery] = useState([]);
  const [basePathPtmGallery, setBasePathPtmGallery] = useState("");
  const [key, setKey] = useState(0);

  const params = new URLSearchParams(window.location.search);



  useEffect(() => {
    // console.log("GallerySlider called");
    const tempPtmId = params.get("ptmId") || 0;
    if (tempPtmId) {
      getGalleryList(tempPtmId);
      setPtmId(tempPtmId);
    }
  }, [key]);


  const getGalleryList = (pPtmId) => {
    // console.log("getGalleryList, pPtmId", pPtmId);
    getGalleryListSvc(pPtmId, galleryListResponse);
  }

  const galleryListResponse = (data) => {
    // console.log("galleryListResponse called, data", data);
    if (data.status === "Success") {
      setLstPtmGallery(data.lstPtmGallery);
      setBasePathPtmGallery(data.basePathPtmGalery);
    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed " + data.error);
    }
  };

  const handleServiceError = (svcMsg) => {
    if (svcMsg === "You are not Logged In") {
      toast.error("You are not logged in. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else if (svcMsg === "Server Timed Out, Login Again") {
      toast.error("Server timed out. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else {
      toast.error(svcMsg);
    }
  };

  const updateKey = () => {
    // console.log("updateKey called");
    setKey(prevKey => prevKey + 1);
  }



  return (
    <div >
      <Header />
      <ToastContainer autoClose={3000} hideProgressBar />
      <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: loader }}>
        <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
      </div>
      <div className="col-md-12 col-xs-12 col-centered padding-remove "
        style={{
          cursor: (loader === "none") ? 'pointer' : 'none',
          pointerEvents: (loader === "none") ? 'auto' : 'none',
          opacity: opacity
        }}
      >
      </div>
      <div className="gallery-slide-component">
        <GallerySlideComponent
          ptmdId={ptmId}
          basePathPtmGallery={basePathPtmGallery}
          lstPtmGallery={lstPtmGallery}
          updateKey={updateKey}
        />
      </div>
    </div>
  )
}

export default GallerySlide;